import { Col, Label, ReactSelectBox } from "client/CommonComponents";
import { useMemo } from "react";

const UtilityVehicle = (props?: any) => {
  const {
    handleSelectionChange,
    managedEquipmentValues,
    seatingCapacityDropDownList,
    managedUtilityVehicleRef,
    capacityDropDownList,
    enclosedCabDropDownList
  } = props

  const seatingCapacityValue:any = useMemo(() => {
    return  seatingCapacityDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.seatingCapacityId)
  }, [managedEquipmentValues?.seatingCapacityId, seatingCapacityDropDownList])

  const enclosedCabValue:any = useMemo(() => {
    return  enclosedCabDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.enclosedCabId)
  }, [managedEquipmentValues?.enclosedCabId, enclosedCabDropDownList])

  const capacityValue:any = useMemo(() => {
    return  capacityDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.capacityId)
  }, [managedEquipmentValues?.capacityId, capacityDropDownList])

  return (<>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="UtilityVehicle_Default_Label">Seating Capacity</Label>
      <ReactSelectBox
        options={seatingCapacityDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'seatingCapacityId', 2)}
        value={seatingCapacityValue}
        selectRef={(element: any) => managedUtilityVehicleRef.current[1] = element}
       data-attribute="UtilityVehicle_Default_SearchSelectBox" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="UtilityVehicle_Default_Label_2">Enclosed Cab</Label>
      <ReactSelectBox
        options={enclosedCabDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'enclosedCabId', 3)}
        value={enclosedCabValue}
        selectRef={(element: any) => managedUtilityVehicleRef.current[2] = element}
       data-attribute="UtilityVehicle_Default_SearchSelectBox_2" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="UtilityVehicle_Default_Label_3">Capacity</Label>
      <ReactSelectBox
        options={capacityDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'capacityId', 4)}
        value={capacityValue}
        selectRef={(element: any) => managedUtilityVehicleRef.current[3] = element}
        isSearchable={true}
       data-attribute="UtilityVehicle_Default_SearchSelectBox_3" />
    </Col>
  </>)
}

export default UtilityVehicle;
